import React from 'react';
import styled from '@emotion/styled/macro';
import ViewSDKClient from './ViewSDKClient';
import { PdfEmbedProps, PdfEventProps } from './pdf-embed.types';
import { DataLayerProps } from 'src/global';

const PdfEmbed: React.FC<PdfEmbedProps> = ({
  embedId,
  url,
  title,
  displayTitle,
  className,
}) => {
  if (displayTitle && url) {
    const isBrowser = typeof window !== 'undefined';
    if (!isBrowser) {
      return null;
    }

    const addEventToDataLayer = (event: PdfEventProps) => {
      const dataToPush: DataLayerProps = {
        event: event.type,
        content: [],
      };

      if (event.type === 'PAGE_VIEW') {
        dataToPush.content!.push({
          fileName: event.data.fileName,
          pageNumber: event.data.pageNumber,
        });
      }
      if (event.type === 'TEXT_SEARCH') {
        dataToPush.content!.push({
          fileName: event.data.fileName,
          searchedText: event.data.searchedText,
        });
      }
      if (event.type === 'DOCUMENT_DOWNLOAD') {
        dataToPush.content!.push({
          fileName: event.data.fileName,
        });
      }

      window.dataLayer.push(dataToPush);
    };

    const pdfEmbedId = `pdf-${embedId}`;

    const viewSDKClient = new ViewSDKClient(url, title, displayTitle);

    viewSDKClient
      .ready()
      .then(() => {
        viewSDKClient.previewFile(pdfEmbedId, {
          embedMode: 'SIZED_CONTAINER',
        });
        viewSDKClient.registerEventsHandler(addEventToDataLayer);
      })
      .catch(error => {
        console.log(
          `PdfEmbed viewSDKClient.ready.then failed with error: ${error}`
        );
      });

    return (
      <div className={className}>
        <div
          id={pdfEmbedId}
          data-testid="pdf-embed"
          className="sized-container-div"
        />
      </div>
    );
  } else {
    console.warn(
      `Pdf embed called with missing props. displayTitle: ${displayTitle}, url: ${url}`
    );
    return null;
  }
};

const StyledPdfEmbed = styled(PdfEmbed)``;

export default StyledPdfEmbed;
